/**
 * @file index.js
 * @author sunxiaofeng01
 * @desc 订单管理
 */

import bendsdk from '@baidu/bend-plugin-sdk';
const routes = [
    {
        path: '/clueOrderManage',
        name: 'clueOrderManage',
        meta: {auth: 'in'},
        component: () => import('./views/index')
    },
    {
        path: '/clueOrderManage/orderDetail',
        name: 'orderDetail',
        meta: {auth: 'in'},
        component: () => import('./views/orderDetail')
    },
    {
        path: '/clueOrderManage/memberDetail',
        name: 'memberDetail',
        meta: {auth: 'in'},
        component: () => import('../member-code-manage/views/index')
    },
    {
        path: '/clueOrderManage/lightDetail',
        name: 'lightDetail',
        meta: {auth: 'in'},
        component: () => import('../member-code-manage/views/index')
    }
];

// 如果有权限控制的话，这里得引入SDK判断权限是否可以调用本插件，或者重插件配置页面读取插件信息
export default class clueOrderManage extends bendsdk.plugin {
    onInstall(router) {
        Array.prototype.push.apply(router.options.routes, routes);
        router.addRoutes(routes);
    }
}
